<app-document-countries
  [name]="'Лицензионное соглашение'"
  [countries]="countries"
></app-document-countries>
